import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaEdit, FaEnvelope, FaUserTimes } from 'react-icons/fa';

import { ActionMenuButtonEllipsis } from 'components';
import { MenuOption } from 'types';

type ManageTeamActionMenuProps = {
  onEdit: () => void;
  onRemove: () => void;
  onResendInvite: () => void;
};

export const ManageTeamActionMenu: React.FC<ManageTeamActionMenuProps> = ({
  onEdit,
  onRemove,
  onResendInvite,
}) => {
  const { t } = useTranslation('manage_team');

  const options: MenuOption[] = [
    {
      label: t('edit', 'Edit'),
      onClick: onEdit,
      icon: FaEdit,
    },
    {
      label: t('resend_invite', 'Resend invite'),
      icon: FaEnvelope,
      onClick: onResendInvite,
    },
    {
      label: t('remove_user', 'Remove user'),
      onClick: onRemove,
      icon: FaUserTimes,
    },
  ];

  return (
    <ActionMenuButtonEllipsis
      options={options}
      ariaLabel={t('manage_team_menu_button', 'Manage Team menu buttons')}
    />
  );
};
